import { sessionStorageService } from '@/app/(intakeForm)/sign-up/get-an-estimate/services/SessionStorageService';
import { getLeadIdFromCookies } from '@/hooks/useLeadIdWithCookies';

export const ensureLeadId = async () => {
  const sessionStorageValue = sessionStorageService.getLeadId();

  if (sessionStorageValue) return sessionStorageValue;

  const cookieValue = await getLeadIdFromCookies();

  if (cookieValue) return cookieValue;
};
